module.exports = __webpack_public_path__ + "media/02 diverse.5c25ce68.mp3";